<template>
  <div class="loufengReport">
    <van-sticky>
      <div class="header">
        <van-icon class="back" name="arrow-left" size="25" color="white" @click="$router.go(-1)" />
        <span class="title">举报</span>
      </div>
    </van-sticky>
    <div class="main">
      <div class="report-box">
        <div class="report-radio">
          <van-radio-group v-model="radio" direction="horizontal" checked-color="rgb(252,21,32)">
            <van-radio name="无效的联系方式">无效的联系方式</van-radio>
            <van-radio name="重复帖子">重复帖子</van-radio>
            <van-radio name="骗子">骗子</van-radio>
          </van-radio-group>
        </div>
        <van-field
          class="content"
          v-model="content"
          rows="4"
          autosize
          size="large"
          type="textarea"
          placeholder="请输入具体原因"
        />
      </div>
      <div class="upload">
        <div class="title">
          照片
        </div>
        <div>
          <van-uploader v-model="fileList" upload-icon="plus" :after-read="upload" @delete="removeImg" />
        </div>
      </div>
      <div class="require">
        <div class="require-title">
          举报说明
        </div>
        <div class="require-content">
          <p>1、每个楼凤只能举报一次，不可重复举报；</p>
          <p>2、举报提供相关截图，官方核实无误，用户获全额退款；</p>
          <p>3、购买楼凤七天后再举报，视为常规举报，不享受退款处理。</p>
        </div>
      </div>
      <div class="bottom">
        <div class="subBtn" @click="subReport">
          提交举报
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import { uploadImg, addReport } from '@/api/loufeng.js';

export default {
  name: 'loufengReport',
  data() {
    return {
      content: '',
      fileList: [],
      uploadImg: [],
      imgs: [],
      loufengId: 0, // 楼凤Id
      radio: '无效的联系方式'
    }
  },
  created() {
    this.getLoufengId();
  },
  methods: {
    getLoufengId() {
      if(localStorage.getItem('loufengId')) {
        this.loufengId = localStorage.getItem('loufengId');
      } else {
        this.loufengId = '';
      }
    },
    // 上传照片
    async upload(fileInfo) {
      let req = new FormData();
      req.append('file', fileInfo.file);
      fileInfo.status = 'uploading';
      fileInfo.message = '上传中...';
      let res = await this.$Api(uploadImg, req);
      if(res && res.code === 200) {
        fileInfo.status = '';
        fileInfo.message = '';
        let tempImg = {
          name: fileInfo.file.name,
          url: res.data.path
        }
        this.uploadImg.push(tempImg);
        this.$toast('照片上传成功');
      } else {
        this.$toast('照片上传异常');
      }
    },
    // 移除照片
    removeImg(file) {
      let tempArr = this.uploadImg.filter(item => {
        if(!(item.name === file.file.name)) {
          return item
        }
      })
      this.uploadImg = tempArr;
    },
    // 提交表单
    async subReport() {
      this.imgs = this.uploadImg.map(item => item.url);
      let req = {
        content: this.content,
        girlId: parseInt(this.loufengId),
        girlType: 'loufeng',
        imgs: this.imgs,
        subject: this.radio
      }
      let res = await this.$Api(addReport, req);
      if(res && res.code === 200) {
        this.$toast('提交成功');
        this.$router.go(-1);
      } else {
        this.$toast(res.tip ? res.tip : res.msg);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .loufengReport{
    .header {
      height: 44px;
      width: 100%;
      background-color: rgb(242,19,19);
      color: white;
      font-size: 20px;
      text-align: center;
      line-height: 44px;
      .back {
        position: absolute;
        left: 14px;
        top: 10px;
      }
    }
    .main{
      padding: 0px 15px;
      .title{
        font-size: 17px;
        height: 47px;
        line-height: 47px;
      }
      .report-box{
        height: 170px;
        .report-radio {
          height: 50px;
          margin-top: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0px 0px 3px 1px rgba(112,112,112, 0.2);
          border-radius: 5px;
        }
        .content{
          margin-top: 15px;
          box-shadow: 0px 0px 3px 1px rgba(112,112,112, 0.2);
          border-radius: 5px;
        }
      }
      .upload{
        margin: 20px 0;
        /deep/ .van-cell {
          padding: unset;
        }
      }
      .require{
        .require-title{
          font-size: 16px;
          height: 40px;
        }
        .require-content{
          font-size: 14px;
          p{
            line-height: 20px;
          }
        }
      }
      .bottom {
        height: 40px;
        margin-top: 40px;
        .subBtn {
          width: 100%;
          height: 40px;
          font-size: 22px;
          color: white;
          text-align: center;
          line-height: 40px;
          background-color: red;
          border-radius: 15px;
        }
      }
    }
  }
  .all-content {
    overflow: auto;
  }
</style>